import React from "react";

const RemoveIcon = ({ width = "16px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={width}
      viewBox="0 0 311.97 382.413"
    >
      <g id="_1345823" data-name="1345823" transform="translate(-47.183 512)">
        <path
          id="Trazado_1"
          data-name="Trazado 1"
          d="M163.712-510.581a21.572,21.572,0,0,0-11.8,10.9c-1.643,3.51-1.793,4.556-1.793,17.7v14.042h-37.2c-40.855,0-41.752.075-47.8,4.481-5.452,3.959-7.245,7.32-12.921,24.5-4.631,14.116-5.3,16.656-4.93,20.017a18.9,18.9,0,0,0,6.2,12.249c4.033,3.51,7.245,4.631,14.639,5.079l6.5.373.448,3.062c.224,1.643,4.556,55.495,9.71,119.579s9.71,118.384,10.083,120.624c2.315,13.37,14.042,25.021,27.561,27.635,2.539.448,32.341.747,82.906.747,65.8,0,79.694-.224,83.952-1.12a35.659,35.659,0,0,0,17.4-10.008c3.51-3.585,7.992-12.025,8.813-16.507.448-2.39,19.868-239.9,19.868-242.967,0-.971.672-1.27,3.212-1.27a20,20,0,0,0,15.087-6.2c7.17-7.32,7.245-11.428.747-31.22-5.3-15.984-7.618-20.316-12.921-24.349-6.125-4.631-6.946-4.705-47.727-4.705H256.925v-11.054a122.168,122.168,0,0,0-.822-15.536,20.6,20.6,0,0,0-13.22-15.984C239.149-511.925,237.058-512,203.3-512,170.658-511.925,167.3-511.851,163.712-510.581Zm70.806,31.818v10.83H172.526v-21.66h61.993Zm97.4,43.544c1.867,5.6,3.436,10.457,3.436,10.83,0,.3-59.453.523-132.2.523s-132.2-.075-132.2-.224c0-.523,6.647-19.942,7.1-20.689.3-.523,39.885-.747,125.479-.747H328.478Zm-18.971,34.656c0,.523-4.332,54.673-9.635,120.251-7.17,88.134-10.008,119.8-10.755,121.371a13.669,13.669,0,0,1-6.722,6.125c-1.419.6-26.814.822-80.74.822H126.516l-3.286-1.718c-6.647-3.286-5.452,6.274-15.984-125.255-5.154-64.308-9.56-118.16-9.784-119.728l-.373-2.764H205.016C290.835-401.459,312.943-401.235,312.943-400.562Z"
          transform="translate(0)"
          fill="#f95151"
        />
        <path
          id="Trazado_2"
          data-name="Trazado 2"
          d="M158.052-344.289a13.174,13.174,0,0,0-3.959,4.407l-1.494,2.614,5.676,103.52c6.2,113.6,5.452,106.06,10.531,109.869,2.913,2.166,9.336,2.166,12.249,0,3.51-2.614,4.855-5.751,4.78-10.979,0-2.539-2.39-49-5.378-103.222-5.826-108.6-5.3-103.222-10.531-106.433A11.663,11.663,0,0,0,158.052-344.289Z"
          transform="translate(-26.681 -42.007)"
          fill="#f95151"
        />
        <path
          id="Trazado_3"
          data-name="Trazado 3"
          d="M246.407-344.519a11.352,11.352,0,0,0-3.959,4.855c-1.419,3.212-1.419,5.6-1.27,106.732.224,103.147.224,103.446,1.793,105.462,2.764,3.809,5.3,5.154,9.486,5.154,4.631,0,8.365-2.241,9.934-6.05.9-2.091,1.046-19.419,1.046-106.135,0-102.1,0-103.67-1.494-106.135A11.636,11.636,0,0,0,246.407-344.519Z"
          transform="translate(-49.084 -42.001)"
          fill="#f95151"
        />
        <path
          id="Trazado_4"
          data-name="Trazado 4"
          d="M331.085-344.381c-3.286,2.166-4.78,5.228-5.154,10.755-.149,2.465-2.614,48.773-5.452,102.923-3.436,67.37-4.855,99.263-4.407,100.981,1.419,4.93,8.067,8.739,13.145,7.469a12.346,12.346,0,0,0,7.394-5.676c.9-1.793,2.091-21.287,6.349-101.728,2.913-54.748,5.154-101.952,5-104.94-.224-5.079-.373-5.527-2.988-8.141-2.465-2.39-3.286-2.764-7.1-2.988C334.372-345.95,333.1-345.726,331.085-344.381Z"
          transform="translate(-68.036 -42.065)"
          fill="#f95151"
        />
      </g>
    </svg>
  );
};

export default RemoveIcon;
